import { BsArrowRight } from "react-icons/bs"
import { Button } from "./parts"
import pdf from '../assets/akbarputra.pdf'

const About = () => {
    return (
        <section id="about" className="flex flex-col md:flex-row gap-5 md:gap-0 items-start md:items-center px-5 md:px-32 md:py-10">
            <div className="flex-1">
                <h1 className="text-4xl font-medium mb-3"><span className="text-primary">Who</span> am i ?</h1>
                <p className="text-lg font-light text-gray-300">I am a freelance front-end developer. I have been in this field for more than 2 years. I have created several projects with html, css, js and most recently I am working on projects using react and react native. In addition, I also have the expertise to design</p>
            </div>
            <div className="flex-1 flex justify-center">
                <Button href={pdf} textColor="text-primary" className="flex items-center gap-6">Read more about me <BsArrowRight size={34} /></Button>
            </div>
        </section>
    )
}

export default About